// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZZTv","title":"styles_title__3Yln1"};